import { WorklogSchema, ZodCreateWorklogSchema, ZodUpdateWorklogSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type Worklog = WorklogSchema;

/**
 * Get a single worklog by ID
 */
export const getWorklog = async (worklogId: string): Promise<Worklog> => {
  const response = await apiClient.get<{ worklog: Worklog }>(`/api/worklog/${worklogId}`);
  return response.data.worklog;
};

/**
 * Get all worklogs
 */
export const getWorklogs = async (): Promise<Worklog[]> => {
  const response = await apiClient.get<{ worklogs: Worklog[] }>("/api/worklog");
  return response.data.worklogs;
};

/**
 * Create a new worklog
 */
export const createWorklog = async (worklogData: ZodCreateWorklogSchema): Promise<Worklog> => {
  const response = await apiClient.post<{ worklog: Worklog }>("/api/worklog", worklogData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.worklog;
};

/**
 * Update an existing worklog
 */
export const updateWorklog = async (worklogData: ZodUpdateWorklogSchema): Promise<Worklog> => {
  const response = await apiClient.put<{ worklog: Worklog }>(`/api/worklog/${worklogData.id}`, worklogData, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data.worklog;
};

/**
 * Delete a worklog
 */
export const deleteWorklog = async (worklogId: string): Promise<{ message: string }> => {
  const response = await apiClient.delete<{ message: string }>(`/api/worklog/${worklogId}`);
  return response.data;
};

export default getWorklog;
